export enum MotorSensoryAssessmentConstants {
  SET_MOTORLA = 'motorSensoryAssessment/SET_MOTORLA',
  SET_MOTORRA = 'motorSensoryAssessment/SET_MOTORRA',
  SET_MOTORLL = 'motorSensoryAssessment/SET_MOTORLL',
  SET_MOTORRL = 'motorSensoryAssessment/SET_MOTORRL',
  SET_SENSORYLA = 'motorSensoryAssessment/SET_SENSORYLA',
  SET_SENSORYRA = 'motorSensoryAssessment/SET_SENSORYRA',
  SET_SENSORYLL = 'motorSensoryAssessment/SET_SENSORYLL',
  SET_SENSORYRL = 'motorSensoryAssessment/SET_SENSORYRL',
  SET_MOTORCOMMENTS = 'motorSensoryAssessment/SET_MOTORCOMMENTS',
  SET_HEADSENSORY = 'motorSensoryAssessment/SET_HEADSENSORY',

  SAVE_MOTOR_SENSORY = 'motorSensoryAssessment/SAVE_NEURO',
  SET_RESPONSE = 'motorSensoryAssessment/SET_RESPONSE',
  SET_MOTOR_SENSORY = 'motorSensoryAssessment/SET_MOTOR_SENSORY',
  RESET_MOTOR_SENSORY_STATE = 'motorSensoryAssessment/RESET_MOTOR_SENSORY_STATE',

  SET_MOTOR_SENSORY_STATE = 'motorSensoryAssessment/SET_MOTOR_SENSORY_STATE',
}
